import { httpClient } from "@/shared/http/httpClient";
import {
    ParityTimeseries,
    ParitySummary,
    ParityDivergencesOutput,
} from "@/features/observability/types/parity.types";

const API_PATH = "/api/v1/analytics/parity";

const fetchSummary = (): Promise<ParitySummary> =>
    httpClient.getJson<ParitySummary>(`${API_PATH}/summary`);

const fetchTimeseries = (): Promise<ParityTimeseries> =>
    httpClient.getJson<ParityTimeseries>(`${API_PATH}/timeseries?granularity=hour`);

const fetchDivergences = (): Promise<ParityDivergencesOutput> =>
    httpClient.getJson<ParityDivergencesOutput>(`${API_PATH}/divergences?limit=30`);

export const shadowParityApi = {
    fetchSummary,
    fetchTimeseries,
    fetchDivergences,
};
